/**
 * GlobalTips
 *
 * Created by Samuel on 2022/8/15
 */
// javascript
import cx from 'clsx';
import * as _ from 'lodash-es';
import React, { useEffect, useRef } from 'react';

import { Dialog } from '@core/component/dialog/Dialog';
import Modal from '@core/component/portal/Modal';

import { ERROR_INFO } from '@/utils/ErrorUtil';

export const modalGlobalTipsName = `mg-globalTips`;
const _DEFAULT_CLOSE_TIME = 2222;
export const GlobalTips = ({ visible, onClose, onVisibleChange, hide, r, e }) => {
	const closeTimer = useRef(null);
	let errorInfo = ERROR_INFO['' + r];
	if (!errorInfo) {
		errorInfo = {
			...ERROR_INFO[-2],
			autoClose: true,
		};
		if (r || e) {
			errorInfo.describe = `${r ? `[${r}] ` : ''}${e || ''}`;
		}
	}
	if (errorInfo.autoClose == null) {
		errorInfo.autoClose = true;
	}

	// 自动关闭相关
	useEffect(() => {
		if (visible && errorInfo.autoClose) {
			if (closeTimer.current) {
				clearTimeout(closeTimer.current);
				closeTimer.current = null;
			}
			closeTimer.current = setTimeout(
				() => {
					if (r === -4) {
						// TODO - 需要重新登录，现在的做法是直接刷新页面
						location.reload();
					}
					hide();
				},
				_.isNumber(errorInfo.autoClose) ? errorInfo.autoClose : _DEFAULT_CLOSE_TIME,
			);
		}
		return () => {
			if (closeTimer.current) {
				clearTimeout(closeTimer.current);
				closeTimer.current = null;
			}
		};
	}, [visible]);

	return (
		<Dialog
			visible={visible}
			className={cx('mg-global-tips', errorInfo.className)}
			closeClickAway
			closeEsc
			onVisibleChange={onVisibleChange}
			onClose={onClose}>
			<div className={'mg-gtBox'}>
				<p className={'mg-gtTips'}>{`${errorInfo.title?.toUpperCase() ?? ''}`}</p>
				{errorInfo.describe ? <p className={'mg-gtDes'}>{`${errorInfo.describe ?? ''}`}</p> : null}
			</div>
		</Dialog>
	);
};

Modal.register(modalGlobalTipsName, GlobalTips);
